import React, { useEffect, useRef, useState } from 'react'
import './Sluzby.scss'

const Sluzby = () => {
  const [visibleCards, setVisibleCards] = useState([])
  const sectionRef = useRef(null)

  const services = [
    {
      id: 1,
      icon: '🚗',
      title: 'Základní kurz',
      subtitle: 'Klasický řidičák skupiny B',
      description: 'Kompletní základní kurz s moderní Škodou Fabia Combi. Teoretická příprava, praktické jízdy a individuální přístup.',
      features: [
        'Teoretická a praktická výuka', 
        'Moderní vozový park Škoda Fabia 1. a 3. generace',
        'Doprava na cvičiště zdarma',
        'E-learningové materiály 📗'
      ],
      popular: true
    },
    {
      id: 2,
      icon: '🏎️',
      title: 'Expresní Solitér',
      subtitle: 'Rychlý kurz s prioritou',
      description: 'Nejrychlejší cesta k řidičskému průkazu! Absolutní přednost při plánování jízd a zkouškách s VIP servisem.',
      features: [
        'Absolutní přednost při jízdách',
        'Absolutní přednost při zkoušce',
        'VIP servis bez čekání 🚀',
        'Maximální flexibilita při plánování jízd'
      ],
      badge: 'Nejrychlejší',
      popular: false,
      class: "express-badge"
    },
    {
      id: 3,
      icon: '🚙',
      title: 'SUV kurz',
      subtitle: 'Řidičák v teréním vozidle',
      description: 'Jedinečný kurz s SUV vozidlem Dacia Duster! Pro ty, kteří chtějí ovládat větší a mohutnější vůz než je běžné.',
      features: [
        'Výcvik ve vozidle Dacia Duster',
        '2 hodiny noční jízdy 🌙',
        'Procvičení pokročilých situací',
        'Příprava na robustní vozidla'
      ],
      badge: 'SUV',
      popular: false,
      class: "suv-badge"
    },
    {
      id: 4,
      icon: '🎯',
      title: 'Kondiční jízdy',
      subtitle: 'Zdokonalení řidičských dovedností',
      description: 'Perfektní pro obnovení sebejistoty za volantem nebo zdokonalení techniky jízdy s flexibilními termíny.',
      features: [
        'Flexibilní termíny podle potřeb',
        'Individuální tempo výuky',
        'Procvičení konkrétních situací',
        'Obnovení sebejistoty za volantem'
      ],
      popular: false
    },
    {
      id: 5,
      icon: '🔄',
      title: 'Přezkoušení',
      subtitle: 'Navrácení řidičského oprávnění',
      description: 'Kompletní příprava na přezkoušení při vracení řidičského průkazu. Obnovíme vaše znalosti a dovednosti.',
      features: [
        'Praktický výcvik na vozidlech',
        'Individuální přístup k přípravě'
      ],
      popular: false
    }
  ]

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const cardIndex = parseInt(entry.target.dataset.index)
            setVisibleCards(prev => [...new Set([...prev, cardIndex])])
          }
        })
      },
      { threshold: 0.2 }
    )

    const cards = sectionRef.current?.querySelectorAll('.service-card')
    cards?.forEach(card => observer.observe(card))

    return () => observer.disconnect()
  }, [])

  const handleServiceClick = (serviceId) => {
    const element = document.getElementById('cenik')
    if (element) {
      const headerHeight = window.innerWidth < 768 ? 80 : 100
      const elementPosition = element.offsetTop
      const offsetPosition = elementPosition - headerHeight

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })
    }
  }

  const handleContactClick = () => {
    const element = document.getElementById('kontakt')
    if (element) {
      const headerHeight = window.innerWidth < 768 ? 80 : 100
      const elementPosition = element.offsetTop
      const offsetPosition = elementPosition - headerHeight

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })
    }
  }

  return (
    <div className="services-section" ref={sectionRef}>
      <div className="section-content">
        <div className="services-header">
          <h2>Naše služby</h2>
          <p>Komplexní řešení pro všechny typy řidičských oprávnění</p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div 
              key={service.id}
              className={`service-card ${visibleCards.includes(index) ? 'visible' : ''} ${service.popular ? 'popular' : ''}`}
              data-index={index}
              onClick={() => handleServiceClick(service.id)}
            >

              {service.popular && <div className="popular-badge">Nejoblíbenější</div>}
              {service.badge && !service.popular && <div className={`feature-badge ${service.class.toLowerCase()}`}>{service.badge}</div>}
              
              <div className="card-header">
                <div className="service-icon">
                  <span>{service.icon}</span>
                  <div className="icon-bg"></div>
                </div>
                <div className="service-title">
                  <h3>{service.title}</h3>
                  <span className="subtitle">{service.subtitle}</span>
                </div>
              </div>

              <div className="card-body">
                <p className="service-description">{service.description}</p>
                
                <div className="service-features">
                  {service.features.map((feature, idx) => (
                    <div key={idx} className="feature-item">
                      <span className="feature-check">✓</span>
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="card-footer">
                <button className="btn btn-outline">
                  Zjistit více
                  <span className="btn-arrow">→</span>
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="services-cta">
          <div className="cta-content">
            <h3>Nejste si jisti, která služba je pro vás?</h3>
            <p>Rádi vám poradíme a najdeme nejlepší řešení pro vaše potřeby</p>
            <button className="btn btn-primary" onClick={handleContactClick}>
              Nezávazná konzultace
            </button>
          </div>
        </div>
      </div>

      {/* Background decorations */}
      <div className="section-decorations">
        <div className="decoration decoration-1"></div>
        <div className="decoration decoration-2"></div>
      </div>
    </div>
  )
}

export default Sluzby